import { Button, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { toShortNumber } from "../../lib/util";

export const proposalColumns: GridColDef[] = [
  {
    field: "ranking",
    headerName: "Rank",
    minWidth: 50,
    editable: false,
    align: "center",
    headerAlign: "center",
    flex: 0.3,
    sortable: false,
  },

  {
    field: "name",
    sortable: false,
    headerName: "Proposal Title",
    minWidth: 280,
    editable: false,
    flex: 1.75,
    renderCell: (params: any) => (
      <Link
        to={`/proposal/${params.value.proposal_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.proposal_name}
      </Link>
    ),
  },

  {
    field: "fund_id",
    sortable: false,
    headerName: "Fund",
    minWidth: 70,
    flex: 0.4,
    editable: false,
  },

  {
    field: "challenge",
    sortable: false,
    headerName: "Challenge",
    minWidth: 250,
    editable: false,
    flex: 1.75,
    renderCell: (params: any) => (
      <Link
        to={`/challenge/${params.value.challenge_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.challenge_name}
      </Link>
    ),
  },

  {
    field: "proposer",
    sortable: false,
    headerName: "Proposer",
    minWidth: 120,
    editable: false,
    flex: 0.75,
    renderCell: (params: any) => (
      <Link
        to={`/proposer/${params.value.proposer_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.proposer_name}
      </Link>
    ),
  },

  {
    field: "status",
    sortable: false,
    headerName: "Status",
    minWidth: 100,
    editable: false,
    flex: 0.6,
    renderCell: (params: any) => {
      return (
        <>
          {params.row.funded_from_leftover ? (
            <Tooltip title="Proposal was sponsored through leftover funds">
              <span>
                {params.row.status === "Yes" ? "Funded" : "Not Funded"}
                <sup style={{ fontSize: "15px", marginTop: "-15px" }}>*</sup>
              </span>
            </Tooltip>
          ) : (
            <>{params.row.status === "Yes" ? "Funded" : "Not Funded"}</>
          )}
        </>
      );
    },
  },

  {
    field: "amount_requested",
    sortable: false,
    headerName: "Amount Requested",
    minWidth: 140,
    editable: false,
    flex: 0.75,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "rating",
    sortable: false,
    headerName: "Rating",
    minWidth: 60,
    flex: 0.5,
    editable: false,
  },

  {
    field: "votes",
    sortable: false,
    headerName: "Result Votes",
    minWidth: 100,
    editable: false,
    flex: 0.75,
    valueFormatter: (value) => toShortNumber(value.value, "comma"),
  },
];

export const proposerColumns: GridColDef[] = [
  {
    field: "ranking",
    sortable: false,
    headerName: "Rank",
    minWidth: 50,
    editable: false,
  },

  {
    field: "name",
    sortable: false,
    headerName: "Proposer",
    minWidth: 140,
    editable: false,
    renderCell: (params: any) => (
      <Link
        to={`/proposer/${params.value.user_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.user_name}
      </Link>
    ),
  },

  {
    field: "avg_rating",
    sortable: false,
    headerName: "Avg Rating",
    minWidth: 100,
    editable: false,
  },

  {
    field: "num_proposals",
    sortable: false,
    headerName: "Num of proposals",
    minWidth: 140,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value),
  },

  {
    field: "funded_proposals",
    sortable: false,
    headerName: "Funded Proposals",
    minWidth: 140,
    valueFormatter: (value) => toShortNumber(value.value),
  },

  {
    field: "amount_requested",
    sortable: false,
    headerName: "Amount Requested",
    minWidth: 140,
    editable: false,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "funded_amount",
    sortable: false,
    headerName: "Funded Amount",
    minWidth: 120,
    editable: false,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "funding_percentage",
    sortable: false,
    headerName: "Funding Percentage",
    minWidth: 145,
    editable: false,
  },
  {
    field: "conversion_percentage",
    sortable: false,
    headerName: "Conversion Percentage",
    minWidth: 170,
    editable: false,
  },

  {
    field: "votes",
    sortable: false,
    headerName: "Total Result Votes",
    minWidth: 140,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value, "comma"),
  },
];

export const allProposerColumns: GridColDef[] = [
  {
    field: "ranking",
    sortable: false,
    headerName: "Rank",
    minWidth: 50,
    editable: false,
  },

  {
    field: "name",
    sortable: false,
    headerName: "Proposer",
    minWidth: 140,
    editable: false,
    renderCell: (params: any) => (
      <Link
        to={`/proposer/${params.value.user_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.user_name}
      </Link>
    ),
  },

  {
    field: "avg_rating",
    sortable: false,
    headerName: "Avg Rating",
    minWidth: 100,
    editable: false,
  },

  {
    field: "highest_rating",
    sortable: false,
    headerName: "Highest Rating",
    minWidth: 120,
    editable: false,
  },

  {
    field: "num_proposals",
    sortable: false,
    headerName: "Num of proposals",
    minWidth: 140,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value),
  },

  {
    field: "funded_proposals",
    sortable: false,
    headerName: "Funded Proposals",
    minWidth: 140,
    valueFormatter: (value) => toShortNumber(value.value),
  },

  {
    field: "amount_requested",
    sortable: false,
    headerName: "Amount Requested",
    minWidth: 140,
    editable: false,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "funded_amount",
    sortable: false,
    headerName: "Funded Amount",
    minWidth: 120,
    editable: false,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "funding_percentage",
    sortable: false,
    headerName: "Funding Percentage",
    minWidth: 145,
    editable: false,
  },
  {
    field: "conversion_percentage",
    sortable: false,
    headerName: "Conversion Percentage",
    minWidth: 170,
    editable: false,
  },

  {
    field: "votes",
    sortable: false,
    headerName: "Result Votes",
    minWidth: 120,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value, "comma"),
  },

  {
    field: "highest_amount_requested",
    sortable: false,
    headerName: "Highest Amount Requested",
    minWidth: 190,
    editable: false,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "total_up_votes",
    sortable: false,
    headerName: "Total Up Votes",
    minWidth: 120,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value, "comma"),
  },

  {
    field: "total_down_votes",
    sortable: false,
    headerName: "Total Down Votes",
    minWidth: 130,
    editable: false,
    valueFormatter: (value) => toShortNumber(value.value, "comma"),
  },
];

export const allChallengeColumns: GridColDef[] = [
  {
    field: "ranking",
    headerName: "Rank",
    minWidth: 50,
    editable: false,
    align: "center",
    headerAlign: "center",
    sortable: false,
    flex: 0.5,
  },

  {
    field: "name",
    sortable: false,
    headerName: "Challenge Name",
    minWidth: 280,
    editable: false,
    flex: 1.75,
    renderCell: (params: any) => (
      <Link
        to={`/challenge/${params.value.challenge_id}`}
        style={{ color: "#546e7a" }}
      >
        {params.value.challenge_name}
      </Link>
    ),
  },

  {
    field: "fund_id",
    sortable: false,
    headerName: "Fund",
    minWidth: 70,
    flex: 0.5,
    editable: false,
    renderCell: (params: any) => (
      <Link
        to={`/fund/${params.row.fund_id}/challenges`}
        style={{ color: "#546e7a" }}
      >
        {params.row.fund_name}
      </Link>
    ),
    // renderCell: (params: any) => (
    //   <Link
    //     to={`/fund/${params.value}/challenges`}
    //     style={{ color: "#546e7a" }}
    //   >
    //     Fund {params.value}
    //   </Link>
    // ),
  },

  {
    field: "challenge_amount",
    sortable: false,
    headerName: "Challenge Amount",
    minWidth: 140,
    editable: false,
    flex: 1,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "amount_requested",
    sortable: false,
    editable: false,
    headerName: "Amount Requested",
    minWidth: 140,
    flex: 0.75,
    valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "funded_amount",
    sortable: false,
    editable: false,
    headerName: "Funded Amount",
    minWidth: 120,
    flex: 0.75,
    renderCell: (params: any) => {
      return (
        <>
          {params.row.funded_from_leftover ? (
            <Tooltip title="Some proposals in this challenge were sponsored through leftover funds">
              <span>
                ${toShortNumber(params.row.funded_amount)}
                <sup style={{ fontSize: "15px", marginTop: "-15px" }}>*</sup>
              </span>
            </Tooltip>
          ) : (
            <>${toShortNumber(params.row.funded_amount)}</>
          )}
        </>
      );
    },
    // valueFormatter: (value) => "$" + toShortNumber(value.value),
  },

  {
    field: "number_of_proposals",
    sortable: false,
    editable: false,
    headerName: "Num of Proposals",
    minWidth: 140,
    flex: 0.75,
    valueFormatter: (value) => toShortNumber(value.value),
  },

  {
    field: "funded_proposals",
    sortable: false,
    editable: false,
    headerName: "Num of Projects",
    minWidth: 140,
    flex: 0.75,
    valueFormatter: (value) => toShortNumber(value.value),
  },
  {
    field: "funded_from_leftover",
    sortable: false,
    editable: false,
    headerName: "IdeaScale Link",
    minWidth: 140,
    flex: 0.75,
    renderCell: (params: any) => (
      <Button
        variant="contained"
        size="small"
        target="_blank"
        href={params.row.ideaScale_url}
      >
        View
      </Button>
    ),
  },
];
